<template>
    <v-row
        class="mt-1"
        justify="center"
    >
        <v-col cols="12" sm="4" lg="2">
            <v-select
                :loading="LoadingSystems"
                v-model="SystemID"
                :items="Systems"
                item-text="SystemName"
                item-value="SystemID"
                :label="$t('components.add_blocks_to_draft.select_system')"
                :disabled="!Systems.length"
                dense
            ></v-select>
        </v-col>
        <v-col cols="12" sm="4" lg="2">
            <v-select
                :loading="LoadingSystemBlocks"
                v-model="BlockID"
                :items="Blocks"
                item-text="BlockName"
                item-value="BlockID"
                :label="$t('components.add_blocks_to_draft.select_block')"
                :disabled="!Blocks.length"
                dense
            ></v-select>
        </v-col>
        <v-col cols="12" sm="4" lg="2">
            <v-select
                :loading="LoadingBlockColors"
                v-model="UnitColorID"
                :items="Colors"
                item-text="UnitColorName"
                item-value="UnitColorID"
                :label="$t('components.add_blocks_to_draft.select_color')"
                :disabled="!Colors.length"
                dense
            ></v-select>
        </v-col>
        <v-col cols="12" sm="4" lg="2">
            <v-select
                :loading="LoadingBlockFrontColors"
                v-model="UnitFrontColorID"
                :items="FrontColors"
                item-text="UnitColorName"
                item-value="UnitColorID"
                :label="$t('components.add_blocks_to_draft.select_front_color')"
                :disabled="!FrontColors.length"
                dense
            ></v-select>
        </v-col>
        <v-col cols="12" sm="4" lg="1">
            <v-select
                v-model="Quantity"
                :items="Quantities"
                :label="$t('components.add_blocks_to_draft.select_quantity')"
                :disabled="!QuantitySelectIsEnabled"
                dense
            ></v-select>
        </v-col>
        <v-col cols="12" sm="4" lg="2">
            <v-btn
                rounded
                color="primary"
                :disabled="!AddBlocksIsEnabled"
                :loading="LoadingStoreDraftedBlocks"
                @click="storeOrderedBlocks"
            >
                {{ $t('components.add_blocks_to_draft.add') }}
            </v-btn>
        </v-col>
    </v-row>
</template>

<!--suppress JSUnusedLocalSymbols -->
<script>
export default {
    name: "AddBlocksToDraft",

    props: {
        draft: Object,
    },

    data() {
        return {
            SystemID: null,
            BlockID: null,
            UnitColorID: null,
            UnitFrontColorID: null,
            Quantity: null,

            LoadingSystems: false,
            Systems: [],
            LoadingSystemBlocks: false,
            Blocks: [],
            LoadingBlockColors: false,
            Colors: [],
            LoadingBlockFrontColors: false,
            FrontColors: [],
            Quantities: [1,2,3,4,5,6,7,8,9,10],

            LoadingStoreDraftedBlocks: false,
        };
    },

    computed: {
        BlockHasNoFront() {
            return this.Colors.length && !this.FrontColors.length;
        },
        QuantitySelectIsEnabled() {
            return this.SystemID !== null
                && this.BlockID !== null
                && this.UnitColorID !== null
                && (this.UnitFrontColorID !== null || this.BlockHasNoFront);
        },
        AddBlocksIsEnabled() {
            return this.QuantitySelectIsEnabled && this.Quantity !== null;
        },
        DraftID() {
            return this.draft
                ? this.draft.DraftID
                : null;
        },
    },

    methods: {
        storeOrderedBlocks() {
            this.LoadingStoreDraftedBlocks = true;

            this.$store.dispatch("storeOrderedBlocks", {
                DraftID: this.DraftID,
                SystemID: this.SystemID,
                BlockID: this.BlockID,
                UnitColorID: this.UnitColorID,
                UnitFrontColorID: this.UnitFrontColorID,
                Quantity: this.Quantity,
            })
                .then(response => {
                    if ([200,201].includes(response.status)) {
                        // this.SystemID = null; // Reset selects

                        this.$store.commit(
                            "showSnackbarSuccess",
                            this.$t('components.add_blocks_to_draft.draft_saved')
                        );

                        this.$emit("addedBlocks", response.data.data);
                    } else {
                        this.$store.commit(
                            "showSnackbarError",
                            this.$t('components.add_blocks_to_draft.draft_failed_to_save')
                        );
                    }
                })
                .catch(error => {})
                .then(() => {
                    this.LoadingStoreDraftedBlocks = false;
                });
        },
    },

    created() {
        this.LoadingSystems = true;

        this.$store.dispatch("loadSystems")
            .then(response => {
                response.status === 200
                    ? this.Systems = response.data.data
                    : this.$store.commit(
                        "showSnackbarError",
                        this.$t('components.add_blocks_to_draft.loading_systems_failed')
                    );
            })
            .catch(error => {})
            .then(() => {
                this.LoadingSystems = false;
            });
    },

    watch: {
        SystemID: function (newSystemID) {
            this.BlockID = null;
            this.Blocks = [];

            if(!newSystemID) return;

            this.LoadingSystemBlocks = true;
            this.$store.dispatch("loadSystemBlocks", newSystemID)
                .then(response => {
                    response.status === 200
                        ? this.Blocks = response.data.data
                        : this.$store.commit(
                            "showSnackbarError",
                            this.$t('components.add_blocks_to_draft.loading_blocks_failed')
                        );
                })
                .catch(error => {})
                .then(() => {
                    this.LoadingSystemBlocks = false;
                });
        },
        BlockID: function (newBlockID) {
            this.UnitColorID = null;
            this.UnitFrontColorID = null;
            this.Quantity = null;
            this.Colors = [];
            this.FrontColors = [];

            if(!newBlockID) return;

            this.LoadingBlockColors = true;
            this.$store.dispatch("loadBlockColors", newBlockID)
                .then(response => {
                    response.status === 200
                        ? this.Colors = response.data.data
                        : this.$store.commit(
                            "showSnackbarError",
                            this.$t('components.add_blocks_to_draft.loading_colors_failed')
                        );
                })
                .catch(error => {})
                .then(() => {
                    this.LoadingBlockColors = false;
                });

            this.LoadingBlockFrontColors = true;
            this.$store.dispatch("loadBlockFrontColors", newBlockID)
                .then(response => {
                    response.status === 200
                        ? this.FrontColors = response.data.data
                        : this.$store.commit(
                            "showSnackbarError",
                            this.$t('components.add_blocks_to_draft.loading_front_colors_failed')
                        );
                })
                .catch(error => {})
                .then(() => {
                    this.LoadingBlockFrontColors = false;
                });
        },
        UnitColorID: function (newUnitColorID) {
            if (this.FrontColors.map(FrontColor => FrontColor.UnitColorID).includes(newUnitColorID)) {
                this.UnitFrontColorID = newUnitColorID;
            }
        },
    },
}
</script>

<style scoped>

</style>
